export default {
    namespaced: true,
    state: {
        enable_mail_delivery: false,
        enable_desktop_notification: false,
        enable_person_mail: false,
        enable_approach_management: false,
        enable_form: false,
        enable_pdf: false,
        enable_seminar_page: false,
        max_user: 0,
        max_domain: 0,
        max_session: 0,
        max_person: 0,
        max_upload_content_byte: 0,
        enable_user_management: false,
        enable_user_admin: false,
        enable_config_admin: false,
        enable_contents_storate: false,
        enable_personal_upload: false,
        enable_personal_download: false,
        is_master: false,
        enable_free_plan: false,
        enable_free_text_allow_additional_range: false,
        enable_freemium_plan: false,
        is_during_trial: false,
        is_during_trial_include_null: false,
        is_ma: false,
        is_ip_analysis: false,
        enable_person_link_company: false,
        enable_person_link_company_process: false,
        enable_business_card_storing: false,
        enable_all_business_card_storing_process: false,
        enable_trial_contents_storage: false,
        enable_trial_seminar_page: false,
        enable_trial_person_mail: false,
        enable_trial_form: false,
        enable_trial_approach_management: false,
        enable_person_condition: false,
        enable_one_to_one_mail: false,
        enable_mail_switch: false,
        enable_mail: false,
        enable_scenario: false,
        enable_ai_support: false,
        enable_company_master: false,
        enable_access_analysis: false
    },
    mutations: {
        // 権限情報をセット
        setAuthorities(state, user_authorities) {
            state.enable_mail_delivery = user_authorities.hasOwnProperty('enable_mail_delivery')
                ? user_authorities.enable_mail_delivery
                : false;
            state.enable_desktop_notification = user_authorities.hasOwnProperty('enable_desktop_notification')
                ? user_authorities.enable_desktop_notification
                : false;
            state.enable_person_mail = user_authorities.hasOwnProperty('enable_person_mail')
                ? user_authorities.enable_person_mail
                : false;
            state.enable_approach_management = user_authorities.hasOwnProperty('enable_approach_management')
                ? user_authorities.enable_approach_management
                : false;
            state.enable_form = user_authorities.hasOwnProperty('enable_form') ? user_authorities.enable_form : false;
            state.enable_pdf = user_authorities.hasOwnProperty('enable_pdf') ? user_authorities.enable_pdf : false;
            state.enable_seminar_page = user_authorities.hasOwnProperty('enable_seminar_page')
                ? user_authorities.enable_seminar_page
                : false;
            state.max_user = user_authorities.hasOwnProperty('max_user') ? user_authorities.max_user : 0;
            state.max_domain = user_authorities.hasOwnProperty('max_domain') ? user_authorities.max_domain : 0;
            state.max_session = user_authorities.hasOwnProperty('max_session') ? user_authorities.max_session : 0;
            state.max_person = user_authorities.hasOwnProperty('max_person') ? user_authorities.max_person : 0;
            state.max_upload_content_byte = user_authorities.hasOwnProperty('max_upload_content_byte') ? user_authorities.max_upload_content_byte : 0;
            state.enable_user_management = user_authorities.hasOwnProperty('enable_user_management')
                ? user_authorities.enable_user_management
                : false;
            state.enable_user_admin = user_authorities.hasOwnProperty('enable_user_admin')
                ? user_authorities.enable_user_admin
                : false;
            state.enable_config_admin = user_authorities.hasOwnProperty('enable_config_admin')
                ? user_authorities.enable_config_admin
                : false;
            state.enable_contents_storate = user_authorities.hasOwnProperty('enable_contents_storate')
                ? user_authorities.enable_contents_storate
                : false;
            state.enable_personal_upload = user_authorities.hasOwnProperty('enable_personal_upload')
                ? user_authorities.enable_personal_upload
                : false;
            state.enable_personal_download = user_authorities.hasOwnProperty('enable_personal_download')
                ? user_authorities.enable_personal_download
                : false;
            state.is_master = user_authorities.hasOwnProperty('is_master')
                ? user_authorities.is_master
                : false;
            state.enable_free_plan = user_authorities.hasOwnProperty('enable_free_plan')
                ? user_authorities.enable_free_plan
                : false;
            state.enable_free_text_allow_additional_range = user_authorities.hasOwnProperty('enable_free_text_allow_additional_range')
                ? user_authorities.enable_free_text_allow_additional_range
                : false;
            state.enable_freemium_plan = user_authorities.hasOwnProperty('enable_freemium_plan')
                ? user_authorities.enable_freemium_plan
                : false;
            state.is_during_trial = user_authorities.hasOwnProperty('is_during_trial')
                ? user_authorities.is_during_trial
                : false;
            state.is_during_trial_include_null = user_authorities.hasOwnProperty('is_during_trial_include_null')
                ? user_authorities.is_during_trial_include_null
                : false;
            state.is_ma = user_authorities.hasOwnProperty('is_ma')
                ? user_authorities.is_ma
                : false;
            state.is_ip_analysis = user_authorities.hasOwnProperty('is_ip_analysis')
                ? user_authorities.is_ip_analysis
                : false;
            state.enable_person_link_company = user_authorities.hasOwnProperty('enable_person_link_company')
                ? user_authorities.enable_person_link_company
                : false;
            state.enable_person_link_company_process = user_authorities.hasOwnProperty(
                'enable_person_link_company_process'
            )
                ? user_authorities.enable_person_link_company_process
                : false;
            state.enable_business_card_storing = user_authorities.hasOwnProperty('enable_business_card_storing')
                ? user_authorities.enable_business_card_storing
                : false;
            state.enable_all_business_card_storing_process = user_authorities.hasOwnProperty(
                'enable_all_business_card_storing_process'
            )
                ? user_authorities.enable_all_business_card_storing_process
                : false;
            state.enable_trial_contents_storage = user_authorities.hasOwnProperty('enable_trial_contents_storage')
                ? user_authorities.enable_trial_contents_storage
                : false;
            state.enable_trial_seminar_page = user_authorities.hasOwnProperty('enable_trial_seminar_page')
                ? user_authorities.enable_trial_seminar_page
                : false;
            state.enable_trial_person_mail = user_authorities.hasOwnProperty('enable_trial_person_mail')
                ? user_authorities.enable_trial_person_mail
                : false;
            state.enable_trial_form = user_authorities.hasOwnProperty('enable_trial_form')
                ? user_authorities.enable_trial_form
                : false;
            state.enable_trial_approach_management = user_authorities.hasOwnProperty('enable_trial_approach_management')
                ? user_authorities.enable_trial_approach_management
                : false;
            state.enable_person_condition = user_authorities.hasOwnProperty('enable_person_condition')
                ? user_authorities.enable_person_condition
                : false;
            state.enable_one_to_one_mail = user_authorities.hasOwnProperty('enable_one_to_one_mail')
                ? user_authorities.enable_one_to_one_mail
                : false;
            state.enable_mail_switch = user_authorities.hasOwnProperty('enable_mail_switch')
                ? user_authorities.enable_mail_switch
                : false;
            state.enable_mail = user_authorities.hasOwnProperty('enable_mail') ? user_authorities.enable_mail : false;
            state.enable_salesforce_cooperation = user_authorities.hasOwnProperty('enable_salesforce_cooperation')
                ? user_authorities.enable_salesforce_cooperation
                : false;
            state.enable_kintone_cooperation = user_authorities.hasOwnProperty('enable_kintone_cooperation')
                ? user_authorities.enable_kintone_cooperation
                : false;
            state.enable_scenario = user_authorities.hasOwnProperty('enable_scenario')
                ? user_authorities.enable_scenario
                : false;
            state.enable_ai_support = user_authorities.hasOwnProperty('enable_ai_support')
                ? user_authorities.enable_ai_support
                : false;
            state.enable_company_master = user_authorities.hasOwnProperty('enable_company_master')
                ? user_authorities.enable_company_master
                : false;
            state.enable_access_analysis = user_authorities.hasOwnProperty('enable_access_analysis')
                ? user_authorities.enable_access_analysis
                : false;
        }
    },
    actions: {},
    getters: {
        // メール配信機能利用権限有無の取得
        getEnableMailDelivery(state) {
            return state.enable_mail_delivery;
        },
        // デスクトップ通知利用フラグ権限有無の取得
        getEnableDesktopNotification(state) {
            return state.enable_desktop_notification;
        },
        // 個人解析・メール配信機能利用権限有無の取得
        getEnablePersonMail(state) {
            return state.enable_person_mail;
        },
        // アプローチ管理機能利用権限有無の取得
        getEnableApproachManagement(state) {
            return state.enable_approach_management;
        },
        // フォーム機能利用権限有無の取得
        getEnableForm(state) {
            return state.enable_form;
        },
        // PDF閲覧解析利用権限有無の取得
        getEnablePdf(state) {
            return state.enable_pdf;
        },
        // セミナーページ機能利用権限有無の取得
        getEnableSeminarPage(state) {
            return state.enable_seminar_page;
        },
        // 登録可能ユーザー数の取得
        getMaxUser(state) {
            return state.max_user;
        },
        // 登録可能ドメイン数の取得
        getMaxDomain(state) {
            return state.max_domain;
        },
        // 計測可能セッション数の取得
        getMaxSession(state) {
            return state.max_session;
        },
        // 登録可能個人マスタ数の取得
        getMaxPerson(state) {
            return state.max_person;
        },
        // 設定機能利用権限有無の取得
        getEnableUserManagement(state) {
            return state.enable_user_management;
        },
        // ユーザー管理機能利用権限有無の取得
        getEnableUesrAdmin(state) {
            return state.enable_user_admin;
        },
        // 設定管理機能利用権限有無の判定
        getEnableConfigAdmin(state) {
            return state.enable_config_admin;
        },
        // コンテンツ管理機能利用権限有無の判定
        getEnableContentsStorage(state) {
            return state.enable_contents_storate;
        },
        // 個人情報アップロード機能利用権限有無の判定
        getEnablePersonalUpload(state) {
            return state.enable_personal_upload;
        },
        // 個人情報ダウンロード機能利用権限有無の判定
        getEnablePersonalDownload(state) {
            return state.enable_personal_download;
        },
        // マスター管理者か判定
        isMaster(state) {
            return state.is_master;
        },
        // 自由項目数を増やすか判定
        getEnableFreeTextAllowAdditionalRange(state) {
            return state.enable_free_text_allow_additional_range;
        },
        // フリーミアムプランを契約しているか判定
        getEnableFreemiumPlan(state) {
            return state.enable_freemium_plan;
        },
        // トライアル期間中か判定
        isDuringTrial(state) {
            return state.is_during_trial;
        },
        // 開始と終了にNullを入っている場合トライアル期間中か判定
        isDuringTrialIncludeNull(state) {
            return state.is_during_trial_include_null;
        },
        // MAか判定
        isMa(state) {
            return state.is_ma;
        },
        // IP解析か判定
        is_ip_analysis(state) {
            return state.is_ip_analysis;
        },
        // 個人リンク企業用権限有無の判定
        getEnablePersonLinkCompany(state) {
            return state.enable_person_link_company;
        },
        // 個人リンク企業用権限有無とトライアル外の判定
        getEnablePersonLinkCompanyProcess(state) {
            return state.enable_person_link_company_process;
        },
        // 名刺保管サービス権限の判定
        getEnableBusinessCardStoring(state) {
            return state.enable_business_card_storing;
        },
        // 名刺保管サービスに関する機能の権限の判定
        getEnableAllBusinessCardStoringProcess(state) {
            return state.enable_all_business_card_storing_process;
        },
        // プランのトライアル情報でコンテンツに関する機能の権限の判定
        getEnableTrialContentsStorage(state) {
            return state.enable_trial_contents_storage;
        },
        // プランのトライアル情報でセミナーページに関する機能の権限の判定
        getEnableTrialSeminarPage(state) {
            return state.enable_trial_seminar_page;
        },
        // プランのトライアル情報で個人メールに関する機能の権限の判定
        getEnableTrialPersonMail(state) {
            return state.enable_trial_person_mail;
        },
        // プランのトライアル情報でフォームに関する機能の権限の判定
        getEnableTrialForm(state) {
            return state.enable_trial_form;
        },
        // プランのトライアル情報でアプローチ管理に関する機能の権限の判定
        getEnableTrialApproachManagement(state) {
            return state.enable_trial_approach_management;
        },
        // 個人絞り込み条件に関する権限の判定
        getEnablePersonCondition(state) {
            return state.enable_person_condition;
        },
        // OneToOneメール権限の判定
        getEnableOneToOneMail(state) {
            return state.enable_one_to_one_mail;
        },
        // メールスイッチ権限の判定
        getEnableMailSwitch(state) {
            return state.enable_mail_switch;
        },
        // メール配信権限の判定
        getEnableMail(state) {
            return state.enable_mail;
        },
        // Salesforce連携権限の判定
        getEnableSalesforceCooperation(state) {
            return state.enable_salesforce_cooperation;
        },
        // Kintone連携権限の判定
        getEnableKintoneCooperation(state) {
            return state.enable_kintone_cooperation;
        },
        // シナリオ権限の判定
        getEnableScenario(state) {
            return state.enable_scenario;
        },
        // AIサポート利用権限の判定
        getEnableAiSupport(state) {
            return state.enable_ai_support;
        },
        // 企業リスト機能利用権限の判定
        getEnableCompanyMaster(state) {
            return state.enable_company_master;
        },
        // アクセス分析機能利用権限の判定
        getEnableAccessAnalysis(state) {
            return state.enable_access_analysis;
        }
    }
};
